<template>
  <b-container fluid>
    <b-row id="toparea" no-gutters>

      <div class="">
        <h2 class="pt-1">{{$t('schedule.ipamTitle')}}
          <b-button v-if="loaded" variant="outline-success">{{$t('schedule.lastUpdateText')}} {{ lastUpdate }}</b-button>
          <b-button v-else-if="!loaded && !tried" variant="outline-warning">{{$t('schedule.loading')}}</b-button>
          <b-button v-if="loaded" variant="outline-danger" class="ml-2" @click="confirmClearAll">Clear All</b-button>
        </h2>
        <p class="d-none d-md-block">{{$t('tutorial.schedulingExample')}}</p>
      </div>

      <!-- at some point in time we need little spinner indicators trigger after the debounce -->
      <b-row class="w-100 m-0 p-0">
        <b-col xl="3" lg="4" md="6" sm="12" xs="12" class="p-1">
          <b-button-group style="width: 100% !important">
            <b-form-input class="" v-model="displayFilter" :placeholder=" $t('schedule.searchDisplay')"></b-form-input>
            <b-dropdown variant="outline-success" id="displaySort" :text="displaySortMethod ? $t('schedule.newest') : $t('schedule.oldest')">
              <b-dropdown-item @click="displaySortMethod = true">{{$t('schedule.newest')}}</b-dropdown-item>
              <b-dropdown-item @click="displaySortMethod = false">{{$t('schedule.oldest')}}</b-dropdown-item>
            </b-dropdown>
          </b-button-group>
        </b-col>
        <b-col xl="3" lg="4" md="6" sm="12" xs="12" class="p-1">
          <b-button-group style="width: 100% !important">
            <b-form-input class="" v-model="campaignFilter" :placeholder= "$t('schedule.searchCampaigns')"></b-form-input>
            <b-dropdown variant="outline-info" id="campaignSort" :text="campaignSortMethod ? $t('schedule.newest') : $t('schedule.oldest')">
              <b-dropdown-item @click="campaignSortMethod = true">{{$t('schedule.newest')}}</b-dropdown-item>
              <b-dropdown-item @click="campaignSortMethod = false">{{$t('schedule.oldest')}}</b-dropdown-item>
            </b-dropdown>
          </b-button-group>
        </b-col>
        <b-col xl="2" lg="2" md="4" sm="12" xs="12" class="p-1">
          <button type="button" style="width: 100%" class="btn btn-outline-success" @click="toggleActive()">{{$t('schedule.active')}} {{ activeSwitch === true ? '☑' : '☐' }}</button>
        </b-col>
        <b-col xl="2" lg="2" md="4" sm="12" xs="12" class="p-1">
          <button type="button" style="width: 100%" class="btn btn-outline-warning" @click="toggleSources()">{{$t('schedule.source')}} {{ sourceSwitch === true ? '☑' : '☐' }}</button>
        </b-col>
        <b-col xl="2" lg="2" md="4" sm="12" xs="12" class="p-1">
          <button type="button" style="width: 100%" class="btn btn-outline-secondary" @click="toggleTags()">Tags {{ tagMode === true ? '☑' : '☐' }}</button>
        </b-col>
      </b-row>
    </b-row>
    <b-row v-if="((displays.length < 1)||((sources.length <1)&&(campaigns.length < 1)))">
    <b-col>
      <div v-if="displays.length < 1" class="text-center">
        <p>{{$t('schedule.noDisplayFound')}}</p>
        <b-button variant="primary" :to="{ name: 'display' }">{{$t('index.displays')}}</b-button>
      </div>
      <div v-else class="text-center">
        <p>{{$t('schedule.noCampaignFound')}}</p>
        <b-button variant="primary" :to="{ name: 'campaign' }" class="mr-2">{{$t('index.campaigns')}}</b-button>
        <b-button variant="primary" :to="{ name: 'source' }">{{$t('index.sources')}}</b-button>
      </div>

    </b-col>
  </b-row>
    <b-row v-else no-gutters>
      <b-table-simple v-if="loaded" :sticky-header="tableHeight" class="m-0" fixed hover responsive>
        <b-thead>
          <b-tr>
            <b-th colspan="2" style="vertical-align:top; width: 12em; min-width: 12em">
              <b-button-group>
                <!-- grey out button if it is the last page -->
                <b-button variant="outline-primary" :disabled="canGoPrevious" @click="previousPage">{{$t('schedule.prePage')}}</b-button>
                <b-button variant="outline-primary" :disabled="canGoNext" @click="nextPage">{{$t('schedule.nexPage')}}</b-button>
              </b-button-group>
            </b-th>
            <template v-for="dc in headerRange">
              <ipam-header class="align-top" :key="dc" :display="filteredDisplays[dc]" :isTag="tagMode"></ipam-header>
            </template>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr :key="row" v-for="row in campaignRange" class="ipam-row">
            <b-th colspan="2" style="width: 12em; min-width: 12em" v-if="filteredRows[row].campaignId">
              <div class="pt-1 pb-1">
                <div>
                  <b-link :id="'popover-target-' + row" class="text-dark ipam-row-name" :to="{ name: 'campaign', params: { campaignId: filteredRows[row].campaignId } }">{{ filteredRows[row].name }}</b-link>
                  <small>{{getCampaignLength(filteredRows[row].media.data)}} seconds</small>
                </div>
                <b-popover v-if="true" custom-class="campaign-preview" :target="'popover-target-' + row" triggers="hover" placement="right">
                  <template #title>{{ filteredRows[row].name }}</template>
                  <prop-player :style="{ width: '20em', height: '15em' }" :media="filteredRows[row].media.data" />
                </b-popover>
              </div>
            </b-th>
            <b-th colspan="2" style="width: 12em; min-width: 12em" v-else>
              <div class="pt-1 pb-1 ">
                <div>
                  <b-badge variant="dark">E2V</b-badge>
                  <b-link class="text-dark ipam-row-name" :to="{ name: 'sources', params: { sourceId: filteredRows[row].sourceId } }"> {{ filteredRows[row].name }}</b-link>
                </div>
              </div>
            </b-th>
            <template v-for="col in Array(displayLimit).keys()">
              <ipam-cell @triggerModal="triggerModal" :key="col" v-bind:content="cells[row][col]"></ipam-cell>
            </template>
          </b-tr>

          <b-button class="mt-1 mb-4 ml-2" v-if="campaignsVisible < filteredRows.length || campaignPage < campaignTotalPages" variant="primary" @click="loadCampaigns">Load More</b-button>
        </b-tbody>
      </b-table-simple>
    </b-row>
    <b-modal id="addCampaign" size="lg" no-fade hide-footer no-stacking>
        <add-campaign
          :selectedCampaign="selectedCampaign"
          :selectedDisplay="selectedDisplay"
          :startingIndex="1"
          :selectDisabled="true"
          @done="closeAndRefresh">
        </add-campaign>
    </b-modal>
    <b-modal id="addCampaignToTag" size="lg" no-fade hide-footer no-stacking>
      <template #modal-title>
        Group booking
      </template>
      <add-campaign
        v-if="selectedTag && selectedTag.displays.length > 0"
        :selectedCampaign="selectedCampaign"
        :selectedDisplay="selectedTag.displays[0]"
        :displayLabel="selectedTag.name"
        :tagDisplays="selectedTag.displays"
        :tagId="selectedTag.tagId"
        :startingIndex="1"
        :selectDisabled="true"
        @done="closeAndRefresh">
      </add-campaign>
    </b-modal>
    <b-modal id="manageCampaignTag" size="lg" no-fade hide-footer no-stacking>
      <manage-campaigns-tag
        :tag="selectedTag"
        :campaign="selectedCampaign"
        @add="$bvModal.hide('manageCampaignTag'); $bvModal.show('addCampaignToTag')"
        @deleted="fetchDisplays">
      </manage-campaigns-tag>
    </b-modal>
    <b-modal id="manageCampaign" size="lg" no-fade hide-footer no-stacking>
      <manage-campaigns
        :display="selectedDisplay"
        :campaign="selectedCampaign"
        @add="$bvModal.show('addCampaign')"
        @deleted="fetchDisplays">
      </manage-campaigns>
    </b-modal>
    <b-modal id="addSource" size="lg" no-fade hide-footer no-stacking>
        <add-source
          :selectedSource="selectedCampaign"
          :selectedDisplay="selectedDisplay"
          :startingIndex="1"
          :selectDisabled="true"
          @done="closeAndRefresh">
        </add-source>
    </b-modal>
    <b-modal id="manageSource" size="lg" no-fade hide-footer no-stacking>
      <manage-sources
        :display="selectedDisplay"
        :source="selectedCampaign"
        :sources="sources"
        @add="$bvModal.show('addSource')"
        @deleted="fetchDisplays">
      </manage-sources>
    </b-modal>
  </b-container>
</template>

<script>
import _ from 'lodash'
import verge from 'verge'

import ManageCampaigns from '@/pages/Scheduling/ManageCampaign/ManageCampaigns.vue'
import ManageCampaignsTag from '@/pages/Scheduling/ManageCampaign/ManageCampaignsTag.vue'
import AddCampaign from '@/pages/Scheduling/AddCampaign/AddCampaign.vue'
// import Campaign from '@/components/Preview/Campaign.vue'

import ManageSources from '@/pages/Scheduling/ManageSource/ManageSources.vue'
import AddSource from '@/pages/Scheduling/AddSource/AddSource.vue'

import IpamHeader from '@/components/IPAM/Header.vue'
import IpamCell from '@/components/IPAM/Cell.vue'
import PropPlayer from '@/components/Player/PropPlayer.vue'
import { confirmDanger } from '@/lib/confirm'
import { clock } from '@/lib/clock'

// this whole module needs better error handling and maybe a dedicated IPAM component

export default {
  components: {
    // Campaign,
    PropPlayer,
    ManageCampaigns,
    ManageCampaignsTag,
    AddCampaign,
    ManageSources,
    AddSource,
    IpamHeader,
    IpamCell,
  },
  props: {
    activeTeam: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      campaigns: [],
      displays: [],
      sources: [],
      filteredRows: [],
      filteredCampaigns: [],
      filteredDisplays: [],
      filteredSources: [],
      cells: [[]],
      viewport: '',
      loaded: false,
      tried: false,
      tableHeight: '',
      // date and time as of the last bookings fetch (re-read on each one): the
      // header shows it as "Last updated", and the cells colour bookings
      // running at that time green.
      ...clock(),
      activeSwitch: false,
      sourceSwitch: true,
      displayOffset: 0,
      displayRange: [],
      activeDisplays: {},
      activeCampaigns: {},
      activeSources: {},
      displayFilter: '',
      campaignFilter: '',
      displaySortMethod: true,
      campaignSortMethod: true,
      selectedTeam: {name:this.$t('schedule.allTeam'),teamId:0},
      selectedTeamId: 0,
      campaignRange: [],
      campaignsVisible: 10,
      campaignLimit: 9,
      campaignPage: 1,
      campaignPageSize: 100,
      campaignTotalPages: 1,
      selectedCampaign: 0,
      selectedDisplay: 0,
      tagMode: localStorage.getItem('ipam_tagMode') === 'true',
      tagColumns: [],
      selectedTag: null,
    }
  },
  mounted () {
    document.documentElement.classList.add('ipam-compact')
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    this.fetchDisplays()
  },
  beforeDestroy: function () {
    document.documentElement.classList.remove('ipam-compact')
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    lastUpdate() {
      return this.time.slice(0, 5)
    },
    canGoPrevious() {
      if (this.displayOffset === 0) {
        return true
      }
      else {
        return false
      }
    },
    canGoNext() {
      if (this.displayOffset + this.displayLimit >= this.filteredDisplays.length) {
        return true
      }
      else {
        return false
      }
    },
    displayLimit() {
      if      (this.viewport === 'xs' && this.filteredDisplays.length >= 3) { return 3 }
      else if (this.viewport === 'sm' && this.filteredDisplays.length >= 4) { return 4 }
      else if (this.viewport === 'md' && this.filteredDisplays.length >= 6) { return 6 }
      else if (this.viewport === 'lg' && this.filteredDisplays.length >= 8) { return 8 }
      else if (this.viewport === 'xl' && this.filteredDisplays.length >= 12) { return 12 }
      else { return this.filteredDisplays.length }
    },
    headerRange() {
      if (this.filteredDisplays.length > 0) {
        if (this.displayOffset + this.displayLimit > this.filteredDisplays.length) {
          return _.range((this.filteredDisplays.length - this.displayLimit), this.filteredDisplays.length)
        }
        else {
          return _.range(this.displayOffset, (this.displayOffset + this.displayLimit))
        }
      }
      else {
        return _.range(this.displayOffset, (this.displayOffset + this.displayLimit))
      }
    },
  },
  watch: {
    'activeTeam': function() {
      this.loaded = false
      this.fetchDisplays()
    },
    viewport: function() {
      let range = _.range(0, this.displayLimit)
      this.displayRange = range
    },
    displaySortMethod: function() {
      if (this.displaySortMethod === true) {
        this.displays = this.displays.sort(function(a, b) { if(a.displayId < b.displayId) { return 1 } else { return -1 } })
      }
      else {
        this.displays = this.displays.sort(function(a, b) { if(a.displayId > b.displayId) { return 1 } else { return -1 } })
      }
      this.buildGrid()
    },
    campaignSortMethod: function() {
      if (this.campaignSortMethod === true) {
        this.campaigns = this.campaigns.sort(function(a, b) { if(a.campaignId < b.campaignId) { return 1 } else { return -1 } })
      }
      else {
        this.campaigns = this.campaigns.sort(function(a, b) { if(a.campaignId > b.campaignId) { return 1 } else { return -1 } })
      }
      this.buildGrid()
    },
    displayFilter: _.debounce(function() { this.displayOffset = 0; this.handleResize() }, 250),
    campaignFilter: _.debounce(function (val) {
      this.campaignsVisible = 10
      if (val && val !== '' && this.campaignTotalPages > 1) {
        // search term entered and not all campaigns loaded — fetch all from API
        const teamId = parseInt(this.activeTeam.id)
        this.$axios.get(`v1/campaigns?include=tags,media&limit=all&team=` + teamId)
          .then(r => {
            this.campaigns = r.data.data
            this.campaignTotalPages = 1 // mark as fully loaded
            this.campaigns.sort((a, b) => a.campaignId < b.campaignId ? 1 : -1)
            this.handleResize()
          })
      } else {
        this.handleResize()
      }
    }, 300),
  },
  methods: {
    // Each display matching the filters once, even if several tag columns hold it.
    clearTargets() {
      return _.uniqBy(this.filteredDisplays.flatMap(c => c.displays || [c]), 'displayId')
    },
    async confirmClearAll() {
      const targets = this.clearTargets()
      const bookings = _.sumBy(targets, d => d.bookings ? d.bookings.data.length : 0)
      if (await confirmDanger(this, 'clearAll', { bookings, displays: targets.length })) this.clearAllBookings()
    },
    clearAllBookings() {
      let requests = []
      for (let d of this.clearTargets()) {
        for (let booking of (d.bookings ? d.bookings.data : [])) {
          requests.push(
            this.$axios.delete('v1/displays/' + d.displayId + '/campaigns/' + booking.id).then(() => {
              d.bookings.data = d.bookings.data.filter(b => b.id !== booking.id)
            })
          )
        }
      }
      Promise.all(requests).then(
        () => {
          this.$notifications.add({ title: 'Cleared', type: 'success', body: 'All campaign bookings removed.', timeout: true })
          this.fetchDisplays()
        },
        () => {
          this.$notifications.add({ title: 'Error', type: 'warning', body: this.$t('notifications.campaignRemoveError'), timeout: true })
        }
      )
    },
    closeAndRefresh() {
      this.$bvModal.hide('manageCampaign')
      this.$bvModal.hide('manageSource')
      this.$bvModal.hide('addCampaign')
      this.$bvModal.hide('addSource')
      this.$bvModal.hide('addCampaignToTag')
      this.$bvModal.hide('manageCampaignTag')
      // only refresh displays — preserve already-loaded campaigns to avoid losing search results
      const teamId = parseInt(this.activeTeam.id)
      this.$axios.get('v1/displays?include=bookings,e2vbookings,tags&limit=all&team=' + teamId)
        .then(r => {
          Object.assign(this, clock())
          this.displays = r.data.data
          this.displays.sort((a, b) => a.displayId < b.displayId ? 1 : -1)
          this.filteredDisplays = this.displays
          this.buildGrid()
        })
    },
    triggerModal(type, cc, dc) {
      this.selectedCampaign = cc
      this.selectedDisplay = dc
      if (type === 'addCampaign') {
        this.$bvModal.show('addCampaign')
      }
      else if (type === 'manageCampaign') {
        this.$bvModal.show('manageCampaign')
      }
      else if (type === 'addSource') {
        this.$bvModal.show('addSource')
      }
      else if (type === 'manageSource') {
        this.$bvModal.show('manageSource')
      }
      else if (type === 'addCampaignToTag') {
        this.selectedTag = dc
        this.$bvModal.show('addCampaignToTag')
      }
      else if (type === 'addSourceToTag') {
        this.selectedTag = dc
        this.$bvModal.show('addCampaignToTag')
      }
      else if (type === 'manageCampaignTag' || type === 'manageSourceTag') {
        this.selectedTag = dc
        this.$bvModal.show('manageCampaignTag')
      }
    },
    removeTagBooking(display, booking) {
      this.$axios.delete('v1/displays/' + display.displayId + '/campaigns/' + booking.id).then(
        () => {
          display.bookings.data = display.bookings.data.filter(b => b.id !== booking.id)
          this.$notifications.add({ title: 'Deleted', type: 'success', body: this.$t('notifications.campaignRemove'), timeout: true })
        },
        () => {
          this.$notifications.add({ title: 'Error', type: 'warning', body: this.$t('notifications.campaignRemoveError'), timeout: true })
        }
      )
    },
    async toggleActive() {
      this.campaignsVisible = 10
      this.displayOffset = 0
      this.activeSwitch = !this.activeSwitch
      if (this.activeSwitch && this.campaignTotalPages > 1) {
        // collect campaignIds that have active bookings from already-loaded displays
        const today = this.date
        const bookedCampaignIds = new Set()
        for (let d of this.displays) {
          for (let b of (d.bookings ? d.bookings.data : [])) {
            if (b.endDate >= today) bookedCampaignIds.add(b.campaignId)
          }
        }
        // find which ones are missing from already-loaded campaigns
        const loadedIds = new Set(this.campaigns.map(c => c.campaignId))
        const missingIds = [...bookedCampaignIds].filter(id => !loadedIds.has(id))
        if (missingIds.length > 0) {
          this.loaded = false
          const teamId = parseInt(this.activeTeam.id)
          const fetched = await Promise.all(
            missingIds.map(id => this.$axios.get(`v1/campaigns/${id}?include=tags,media&team=` + teamId)
              .then(r => r.data.data)
              .catch(() => null)
            )
          )
          const valid = fetched.filter(c => c !== null)
          this.campaigns = this.campaigns.concat(valid)
          this.campaigns.sort((a, b) => a.campaignId < b.campaignId ? 1 : -1)
        }
      }
      this.handleResize()
    },
    toggleSources() {
      this.campaignsVisible = 10
      this.displayOffset = 0
      this.sourceSwitch = !this.sourceSwitch
      this.handleResize()
    },
    toggleTags() {
      this.loaded = false
      this.displayOffset = 0
      this.tagMode = !this.tagMode
      localStorage.setItem('ipam_tagMode', this.tagMode)
      this.handleResize()
    },
    buildTagColumns(displays) {
      let tagMap = {}
      for (let display of displays) {
        let tagList = display.tags && display.tags.data ? display.tags.data : []
        for (let tag of tagList) {
          let id = tag.tagId || tag.id || tag.tag
          let label = tag.tag || tag.name || String(id)
          if (!tagMap[id]) {
            tagMap[id] = { tagId: id, name: label, displays: [], displayCount: 0 }
          }
          tagMap[id].displays.push(display)
          tagMap[id].displayCount++
        }
      }
      return Object.values(tagMap).sort((a, b) => String(a.tagId).localeCompare(String(b.tagId)))
    },
    getTeamID(obj) {
      this.selectedTeamId = obj ? obj.teamId : 0
      this.handleResize()
    },
    loadCampaigns() {
      this.campaignsVisible = this.campaignsVisible + this.campaignLimit
      // if we're about to show campaigns beyond what's loaded, fetch next page
      if (this.campaignsVisible >= this.campaigns.length && this.campaignPage < this.campaignTotalPages) {
        this.campaignPage++
        const teamId = parseInt(this.activeTeam.id)
        this.$axios.get(`v1/campaigns?include=tags,media&limit=${this.campaignPageSize}&page=${this.campaignPage}&team=` + teamId)
          .then(res => {
            this.campaigns = this.campaigns.concat(res.data.data)
            this.buildGrid()
          })
      } else {
        this.buildGrid()
      }
    },
    previousPage() {
      if (this.displayOffset === 0) {
        // do nothing
      }
      else if (this.displayOffset < this.displayLimit) {
        this.displayOffset = 0
      }
      // there might be an issue here? idk
      else {
        this.displayOffset = this.displayOffset - this.displayLimit
      }
      this.buildGrid()
    },
    nextPage() {
      if ((this.displayOffset + this.displayLimit) > (this.filteredDisplays.length - this.displayLimit)) {
        this.displayOffset = this.filteredDisplays.length - this.displayLimit
      }
      if ((this.displayOffset + this.displayLimit) === this.filteredDisplays.length) {
        this.displayOffset = this.filteredDisplays.length - this.displayLimit
      }
      else {
        this.displayOffset = this.displayOffset + this.displayLimit
      }
      this.buildGrid()
    },
    handleResize: _.debounce(
      function () {
        let toparea = document.getElementById('toparea')
        let navbar = document.getElementById('navbar')
        let topheight = verge.rectangle(toparea).height
        let navbarheight = verge.rectangle(navbar).height
        this.tableHeight = parseInt(verge.viewportH() - topheight - navbarheight) + 'px'

        // add check for horizontal width only
        let width = verge.viewportW()
        if      (width > 1900) { this.viewport = 'xl' }
        else if (width > 1200) { this.viewport = 'lg' }
        else if (width > 992)  { this.viewport = 'md' }
        else if (width > 768)  { this.viewport = 'sm' }
        else if (width > 480)  { this.viewport = 'xs' }
        else                   { this.viewport = 'xs' }
        this.loaded = false
        this.buildGrid()
    }, 200),
    fetchDisplays () {
      this.displays = []
      this.tried = false
      const teamId = parseInt(this.activeTeam.id)
      this.campaignPage = 1
      const reqDisplays = this.$axios.get('v1/displays?include=bookings,e2vbookings,tags&limit=all&team=' + teamId)
        .then(r => { Object.assign(this, clock()); this.displays = r.data.data; this.displayMeta = r.data.meta; this.displays.sort((a, b) => a.displayId < b.displayId ? 1 : -1); this.filteredDisplays = this.displays })
        .catch(e => { console.error('IPAM displays fetch failed:', e?.response?.status, e?.response?.data); this.tried = true; this.displayMeta = { totalPages: 0 }; this.displays = []; this.filteredDisplays = [] })
      const campaignUrl = `v1/campaigns?include=tags,media&limit=${this.campaignPageSize}&page=1&team=` + teamId
      const reqCampaigns = this.$axios.get(campaignUrl)
        .then(r => { this.campaigns = r.data.data; this.campaignTotalPages = r.data.meta ? r.data.meta.totalPages : 1; this.campaigns.sort((a, b) => a.campaignId < b.campaignId ? 1 : -1); this.filteredCampaigns = this.campaigns })
        .catch(e => { console.error('IPAM campaigns fetch failed:', e?.response?.status, e?.response?.data); this.campaigns = []; this.filteredCampaigns = [] })
      const reqSources = this.$axios.get('v1/sources?limit=all&team=' + teamId)
        .then(r => { this.sources = r.data.data; this.sources.sort((a, b) => a.sourceId < b.sourceId ? 1 : -1); this.filteredSources = this.sources })
        .catch(() => { this.sources = []; this.filteredSources = [] })
      Promise.all([reqDisplays, reqCampaigns, reqSources]).then(() => this.buildGrid())
    },
    getCampaignLength (media) {
      let duration = 0
      for (let item of media) {
        duration = parseInt(item.end) > duration ? parseInt(item.end) : duration
      }
      return duration
    },
    buildGrid() {
      if (((this.campaigns.length > 0)&&(this.displays.length > 0)) || ((this.sources.length > 0)&&(this.displays.length > 0))) {

        this.filteredDisplays = this.displays.filter(function(display) {
            return display.name.toLowerCase().includes(this.displayFilter.toLowerCase())
        }, this)

        this.filteredCampaigns = this.campaigns.filter(function(campaign) {
            return campaign.name.toLowerCase().includes(this.campaignFilter.toLowerCase())
        }, this)


        if (this.sourceSwitch !== true) {
          this.filteredSources = this.sources.filter(function(source) {
              return source.name.toLowerCase().includes(this.campaignFilter.toLowerCase())
           }, this)
        }
        else {
          this.filteredSources = []
        }

        this.activeCampaigns = []
        this.activeSources = []
        this.activeDisplays = []

        if (this.activeSwitch === true) {
          for(let display of this.filteredDisplays) {
            let maybeBookings = display.bookings.data.filter(booking => booking.endDate > this.date)
            if (maybeBookings.length !== 0) {
              for (let booking of maybeBookings) {
                this.activeDisplays[display.displayId] = 1
                this.activeCampaigns[booking.campaignId] = 1
              }
            }
            let maybeE2vBookings = display.e2vbookings.data.filter(booking => booking.endDate > this.date)
            if (maybeE2vBookings.length !== 0) {
              for (let e2vbooking of maybeE2vBookings) {
                this.activeDisplays[display.displayId] = 1
                this.activeSources[e2vbooking.sourceId] = 1
              }
            }
          }
          this.filteredCampaigns = this.filteredCampaigns.filter(campaign => this.activeCampaigns[campaign.campaignId] == 1)
          this.filteredSources = this.filteredSources.filter(source => this.activeSources[source.sourceId] == 1)
          this.filteredDisplays = this.filteredDisplays.filter(display => this.activeDisplays[display.displayId] == 1)
        }

        this.filteredRows = this.filteredSources.concat(this.filteredCampaigns)

        if (this.tagMode) {
          this.tagColumns = this.buildTagColumns(this.filteredDisplays)
          this.filteredDisplays = this.tagColumns
        }

        // use local colCount so tag-mode reassignment of filteredDisplays is reflected immediately
        let colCount = this.filteredDisplays.length

        // construct the grid
        for (let row in this.filteredRows) {
          if ((row < this.campaignsVisible) && (row < this.filteredRows.length)) {
          if (!this.cells[row]) {
            this.$set(this.cells, row, [])
          }
          _.range(this.displayOffset, (this.displayOffset + colCount)).forEach(
            function (virtual, index) {
              this.$set(this.cells[row], index,
              { date: this.date,
                time: this.time,
                name: 'ADD',
                isTag: this.tagMode,
                cc: this.filteredRows[row],
                dc: this.filteredDisplays[virtual] })
            }, this)
          }
        }

        this.campaignRange = _.range(0, (this.campaignsVisible > this.filteredRows.length ? this.filteredRows.length : this.campaignsVisible))
        this.loaded = true

        // construct the grid
        // for (let campaign in this.filteredCampaigns) {
        //   if ((campaign < this.campaignsVisible) && (campaign < this.filteredCampaigns.length)) {
        //   if (!this.cells[campaign]) {
        //     this.$set(this.cells, campaign, [])
        //   }
        //   _.range(this.displayOffset, (this.displayOffset + this.displayLimit)).forEach(
        //     function (virtual, index) {
        //       this.$set(this.cells[campaign], index,
        //       { date: this.date,
        //         time: this.time,
        //         name: 'ADD',
        //         cc: this.filteredCampaigns[campaign],
        //         dc: this.filteredDisplays[virtual] })
        //     }, this)
        //   }
        // }
        // this can probably be converted to a computed property
        // this.campaignRange = _.range(0, (this.campaignsVisible > this.filteredCampaigns.length ? this.filteredCampaigns.length : this.campaignsVisible))
        // this.loaded = true
      }
    }
  },
}
</script>

<style>
.ipam-row-name {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 12em;
}

.ipam_cell {
  cursor: pointer !important;
  text-overflow: ellipsis;
}

.ipam_cell:hover {
  cursor: pointer !important;
  background: red;
}

/* Compact scale for the grid on phones; the class is on <html> only while this page is open. */
@media screen and (max-width: 767px) {
  html.ipam-compact {
    font-size: 3vw
  }
}

@media screen and (max-width: 575px) {
  #toparea h2 {
    font-size: 1.6rem;
  }
}

.campaign-preview {
  max-width: 50em;
  height: 20em;
}

</style>
